module.exports = __webpack_public_path__ + "img/41.23a865ae.jpg";